import React, { PureComponent } from 'react'
import { Panel, Button, OverlayTrigger, Tooltip, Col } from 'react-bootstrap'
import SimpleTablePage from '../../../../containers/commons/general/SimpleTablePage'
import { compareValues } from '../../../../util/utils'
import { fleetsTab } from '../../../../constants/management/fleets'
import * as fleetsUtils from '../../../../util/management/fleetsUtils'
import DeliveryDetailsFleetModalPage from '../../../../containers/management/fleets/auxModals/DeliveryDetailsFleetModalPage'

class DeliveryFleetListComponent extends PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      openDeliveryPanel: false,
      filters: {
        orderBy: '+number'
      },
      fieldsDate: ['realDeliveryDate']
    }
  }

  collapsePanelDossier () {
    var newState = !this.state.openDeliveryPanel
    this.setState({ openDeliveryPanel: newState })
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.props.fleet && !this.props.create && ((this.props.tabActiveKey !== prevProps.tabActiveKey && this.props.tabActiveKey === fleetsTab.FLEETS_DATA && this.state.openDeliveryPanel) || (this.props.tabActiveKey === fleetsTab.FLEETS_DATA && this.state.openDeliveryPanel && this.state.openDeliveryPanel !== prevState.openDeliveryPanel))) {
      this.updateDossiers()
    }
  }

  getSnapshotBeforeUpdate (prevProps) {
    return null
  }

  getIconClass (field) {
    if (this.state.filters.orderBy.includes(field)) {
      return this.state.filters.orderBy.includes('-') ? 'ico-sort-selected-asc' : 'ico-sort-selected-desc'
    } else {
      return 'ico-sort'
    }
  }

  onOrderChange (e) {
    const newOrderBy = this.state.filters.orderBy.includes(`+${e.currentTarget.dataset.field}`) ? `-${e.currentTarget.dataset.field}` : `+${e.currentTarget.dataset.field}`
    this.setState({ filters: { orderBy: newOrderBy } })
    this.order(e.currentTarget.dataset.field, newOrderBy.includes('+') ? 'asc' : 'desc')
  }

  order (field, order) {
    let dossiers = JSON.parse(JSON.stringify(this.props.deliveryFleetDetails))
    dossiers = dossiers.sort(compareValues(field, order, this.state.fieldsDate.includes(field)))
    this.props.actions.getDeliveriesDetailsFleetSuccess(dossiers)
  }

  updateDossiers () {
    if (this.props.fleet && !this.props.create) {
      this.props.actions.getDeliveriesDetailsFleet(this.props.fleet.fleetId)
      if (!this.props.dossierFleetDetails || this.props.dossierFleetDetails.length === 0) {
        this.props.actions.getDossierDetailsFleet(this.props.fleet.fleetId)
      }
    }
  }

  printDocument (dossierList) {
    this.props.executeFunctionByName('setOperateActionPrintDeliveryNoteProcess', fleetsUtils, this.props.dossierFleetDetails.filter(dossier => dossierList.includes(dossier.dossierId)), this.props, this.setState.bind(this), true)
  }

  openDetail (fleetDeliveryId) {
    this.props.actions.openDeliveryDetailsFleetModal(fleetDeliveryId)
  }

  addToAll () {
    this.props.executeFunctionByName('setDeliveryData', fleetsUtils, this.props.dossierFleetDetails, this.props, this.setState.bind(this), (this.props.deliveryFleetDetails && this.props.deliveryFleetDetails.length > 0))
  }

  fildState (field, value) {
    this.setState({ [field]: value })
  }

  render () {
    const {
      t,
      deliveryFleetDetails,
      readOnlyFields
    } = this.props
    const tKey = 'MANAGEMENT.FLEETS_TAB.'
    const printDocument = (<Tooltip id="printDocument">{t(`${tKey}DELIVERY_FLEET_DOCUMENT`)}</Tooltip>)
    const viewDetail = (<Tooltip id="viewDetail">{t(`${tKey}DETAIL`)}</Tooltip>)

    let columnsTable = [
      <th key={0} data-field="realDeliveryDate" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}REAL_DELIVERY_DATE`)}&nbsp;<i className={this.getIconClass('realDeliveryDate')}></i>
      </th>,
      <th key={1} data-field="realDeliveryTime" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}REAL_DELIVERY_TIME`)}&nbsp;<i className={this.getIconClass('realDeliveryTime')}></i>
      </th>,
      <th key={3} data-field="deliveryCity" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}FLEET_DELIVERY_CITY`)}&nbsp;<i className={this.getIconClass('deliveryCity')}/>
      </th>,
      <th key={4} data-field="realDeliveryAddress" onClick={(event) => this.onOrderChange(event)}>
        {t(`${tKey}REAL_DELIVERY_ADDRESS`)}&nbsp;<i className={this.getIconClass('realDeliveryAddress')}></i>
      </th>,
      <th key={6} data-field="dossierCount" onClick={(event) => this.onOrderChange(event)} className='number-column'>
        {t(`${tKey}DOSSIERS`)}&nbsp;<i className={this.getIconClass('dossierCount')}/>
      </th>,
      <th key={5} data-field="document" className='number-column'>
        {t(`${tKey}DELIVERY_FLEET_DOCUMENT`)}&nbsp;
      </th>,
      <th key={7} data-field="details" className='number-column'>
        {t(`${tKey}DETAIL`)}&nbsp;
      </th>
    ]

    return (
      <>
        <DeliveryDetailsFleetModalPage
          executeFunctionByName={this.props.executeFunctionByName}
          dossierFleetDetails={this.props.dossierFleetDetails}
          fleetData={this.props.fleetData}
          fleet={this.props.fleet}
          create={this.props.create}
          fildState={this.fildState.bind(this)}
          openDeliveryPanel={this.state.openDeliveryPanel}
          updateDossiers={this.updateDossiers.bind(this)}
          deliveryFleetDetails={this.props.deliveryFleetDetails}
        />
        <div id='deliveryFleetListComponent' className="_nf dossier-panel" >
          <div id="deliveriesFleetHeader" className="header-panel  fleet-panel-box" onClick={() => this.collapsePanelDossier()}>

            <div className="name-wrapper fleet-panel-box-title">
              <h4>{t(`${tKey}DELIVERIES`)}</h4>
            </div>

            <i id="deliveriesFleetArrow" className={this.state.openDeliveryPanel ? 'ico-arrow-black-down fleet-panel-box-caret' : 'ico-arrow-black-up fleet-panel-box-caret'} />

          </div>
          <Panel expanded={this.state.openDeliveryPanel} onToggle={() => {}}>
            <Panel.Collapse>
              <div id="fleet-dossier-details-table">
                <SimpleTablePage
                  columns={columnsTable}
                  rows={deliveryFleetDetails && deliveryFleetDetails.map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.realDeliveryDate}</td>
                      <td>{row.realDeliveryTime}</td>
                      <td>{row.deliveryCity}</td>
                      <td>{row.realDeliveryAddress}</td>
                      <td className='number-column width-10'>{row.dossierCount}</td>
                      <td className='number-column width-10'>
                        { row.dossierList && row.dossierList.length > 0 ? <OverlayTrigger placement="left" className="documentToolTipFleet" overlay={printDocument}>
                          <a onClick={() => this.printDocument(row.dossierList)}>
                            <i id={'delivery_printDocument' + idx} className="iDocIcon-print-multifunction-printer font-size-large blue"></i>
                          </a>
                        </OverlayTrigger>
                          : <i id={'delivery_printDocument' + idx} className="iDocIcon-print-multifunction-printer font-size-large grey"></i>
                        }
                      </td>
                      <td className='number-column width-10'>
                        <OverlayTrigger placement="left" className="documentToolTipFleet" overlay={viewDetail}>
                          <a onClick={() => this.openDetail(row.fleetDeliveryId)}>
                            {<i id={'deliveryDetail_' + idx} className="iDocIcon-visibility-eye font-size-large blue pointer"></i>}
                          </a>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                ></SimpleTablePage>
                <Col sm={4}>
                  <div className="button-table-wrapper">
                    {!readOnlyFields && this.props.fleetId !== '-1' && (
                      <Button
                        id='deliveryFleetButton'
                        className="_Btn new"
                        onClick={() => this.addToAll()}
                      >
                        {'+ ' + t(`${tKey}ADD`)}
                      </Button>)}
                  </div>
                </Col>
              </div>

            </Panel.Collapse>
          </Panel>
        </div>

      </>
    )
  }
}

export default DeliveryFleetListComponent
